module.exports = __webpack_public_path__ + "static/media/57_tn.d9740edc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/57_tn.jpg
// module id = 365
// module chunks = 0